import { AbstractDTO } from "./abstract";

export class SolrOptionsTableDTO extends AbstractDTO {
    search: string;
    pageNumber: number;
    filters = [];
    itemsPerPage: number;
    isGroupBy: boolean;
    sort: string;
    stats: boolean;
    statsField: string;
    facet: boolean;
    facetRange: string;
    facetRangeArray: [];
    facetRangeStart: string;
    facetRangeEnd: string;
    facetRangeGap: string;
    extraQryString: string;
    searchEntityField;
    searchEntity;
    groupField: string;
    isFacet: boolean;
    notificationVar: string;
    entityTypeVar: any;
    entityVar: any;
    entityUri: string;
    parentNodeId: number;
    searchFields: [];
    additionalFQ: [];
    productType: Array<string>;
    groupLimit: number;

    constructor(attributes?: object) {
        super(attributes);
        attributes = attributes || {};

        this.search = attributes['search'] || '';
        this.pageNumber = attributes['pageNumber'] || 1;
        this.filters = attributes['filters'] || [];
        this.sort = attributes['sort'] || '';
        this.stats = attributes['stats'] || false;
        this.statsField = attributes['statsField'] || '';
        this.facet = attributes['facet'] || false;
        this.facetRange = attributes['facetRange'] || '';
        this.facetRangeStart = attributes['facetRangeStart'] || '';
        this.facetRangeEnd = attributes['facetRangeEnd'] || '';
        this.facetRangeGap = attributes['facetRangeGap'] || '';
        this.extraQryString = attributes['extraQryString'] || '';
        this.itemsPerPage = attributes['itemsPerPage'] || '';
        this.searchEntityField = attributes['searchEntityField'] || [];
        this.searchEntity = attributes['searchEntity'] || null;
        this.groupField = attributes['groupField'] || null;
        this.isGroupBy = attributes['isGroupBy'] || null;
        this.isFacet = attributes['isFacet'] || null;
        this.entityTypeVar = attributes['entityTypeVar'] || null;
        this.entityVar = attributes['entityVar'] || null;
        this.entityUri = attributes['entityUri'] || null;
        this.parentNodeId = attributes['parentNodeId'] || null;
        this.searchFields = attributes['searchFields'] || null;
        this.additionalFQ = attributes['additionalFQ'] || [];
        this.productType = attributes['productType'] || null;
        this.facetRangeArray = attributes['facetRangeArray'] || null;
        this.groupLimit = attributes['groupLimit'] || 1;
    }

}
